// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"TabelaEKompanive_containerDashboardP__dqCwf","mobileResponsive":"TabelaEKompanive_mobileResponsive__l4d4E"};